var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.33331 13.6667H12.6666V12.3334H3.33331V13.6667ZM3.33331 7.00004H5.99998V11H9.99998V7.00004H12.6666L7.99998 2.33337L3.33331 7.00004Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }